export default function convertRestrictionToString(characterRestriction) {
    if (!characterRestriction)
        return undefined;
    if (typeof characterRestriction === 'number')
        return characterRestriction.toString();
    const { min, max } = characterRestriction;
    const separator = '-';
    return `${min}${separator}${max}`;
}
